'use client';

export { default } from './TableRow';
export { default as tableRowClasses } from './tableRowClasses';
export * from './tableRowClasses';